import classNames from 'clsx';
import React from 'react';

import styles from './Menu.scss';

export interface MenuOption {
  readonly text: string | React.ReactNode;
  readonly value?: string | number | boolean;
  readonly data?: string | number | object;
}

export interface MenuProps {
  options?: MenuOption[];
  className?: string;
  onSelect(option: MenuOption): void;
}

class Menu extends React.PureComponent<MenuProps> {
  cn = classNames(styles.menu, this.props.className);

  handleClick = (option: MenuOption) => (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.props.onSelect(option);
  };

  render() {
    return (
      <ul className={this.cn}>
        {this.props.options?.map((option, index) => (
          <li className={styles.option} key={index}>
            <button type="button" onClick={this.handleClick(option)}>
              {option.text}
            </button>
          </li>
        ))}
      </ul>
    );
  }
}

export default Menu;
